(() => {
  if (window.gbShareCartLoaded) return;
  window.gbShareCartLoaded = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('[data-gb-share-cart]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.parentElement.querySelector('[role="status"]');
    if (status) status.textContent = '';
    const sameTab = window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;
    const popup = sameTab ? null : window.open('about:blank', '_blank');
    if (popup) popup.opener = null;
    link.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!cart.items?.length) throw new Error('Cart empty');
      const quantities = new Map();
      for (const item of cart.items) {
        const id = String(item.variant_id);
        quantities.set(id, (quantities.get(id) || 0) + item.quantity);
      }
      const lines = [...quantities].map(([id, quantity]) => id + ':' + quantity).join(',');
      const cartUrl = new URL(root + 'cart/' + lines, window.location.origin);
      cartUrl.searchParams.set('storefront', 'true');
      const whatsappUrl = 'https://wa.me/?text=' + encodeURIComponent(link.dataset.shareIntro + '\n' + cartUrl.href);
      link.href = whatsappUrl;
      if (popup && !popup.closed) popup.location.replace(whatsappUrl);
      else window.location.assign(whatsappUrl);
    } catch {
      if (popup && !popup.closed) popup.close();
      if (status) status.textContent = link.dataset.shareError;
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
